"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RecordCondition_1 = require("./RecordCondition");
class RootCondition extends RecordCondition_1.RecordCondition {
    constructor(value, propertyConditions) {
        super(propertyConditions);
        this.value = value;
    }
    withOptions(options) {
        this.setOptions(options);
        return this;
    }
    evaluate() {
        const result = this.isFulfilled(this.value);
        return result.fulfilled;
    }
    explain() {
        return this.isFulfilled(this.value);
    }
    isFulfilled(value) {
        const result = super.isFulfilled(value);
        if (result.reasons) {
            result.reasons.map((reason) => {
                reason.path = reason.path.length === 0 ? "$" : "$." + reason.path;
                return reason;
            });
        }
        return result;
    }
}
exports.RootCondition = RootCondition;
//# sourceMappingURL=RootCondition.js.map